import script from "./FileImporterHelpDoc.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileImporterHelpDoc.vue?vue&type=script&setup=true&lang=ts"

import "./FileImporterHelpDoc.vue?vue&type=style&index=0&id=37c07442&scoped=true&lang=css"

import exportComponent from "/builds/SalesIT/ijaa/import-tool/ls-import-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c07442"]])

export default __exports__